/* Guest requests (docs/API.md §13 → Enums). */
export enum RequestKind {
    Booking     = 'booking',
    RoomService = 'room_service',
    /** "Nekaj manjka?" from Vaša soba (§13.6). */
    Housekeeping = 'housekeeping',
    /** A late check-out, an extra night, a taxi or a restaurant table, asked of Milo (§13.7). */
    Reception    = 'reception',
}

export const REQUEST_KINDS: RequestKind[] = [RequestKind.RoomService, RequestKind.Booking, RequestKind.Housekeeping, RequestKind.Reception]

/** What a request to the reception is about (§13.7). */
export enum ReceptionType {
    LateCheckout = 'late_checkout',
    ExtraNight   = 'extra_night',
    Taxi         = 'taxi',
    Table        = 'table',
}

/** What a housekeeping request is about (§13.6): Manjka · Potrebujem še · Zamenjaj · Ne deluje. */
export enum HousekeepingType {
    MissingItem = 'missing_item',
    ExtraItem   = 'extra_item',
    /** "Zamenjaj": fresh towels, bed linen for the used ones (2026-11-01). */
    Replace     = 'replace',
    Broken      = 'broken',
}

export enum RequestStatus {
    Pending   = 'pending',
    Accepted  = 'accepted',
    Declined  = 'declined',
    OnTheWay  = 'on_the_way',
    Delivered = 'delivered',
    Cancelled = 'cancelled',
    /** Housekeeping only: "Urejeno" (§13.6). */
    Done      = 'done',
}

export const REQUEST_STATUSES: RequestStatus[] = [
    RequestStatus.Pending, RequestStatus.Accepted, RequestStatus.OnTheWay, RequestStatus.Delivered,
    RequestStatus.Done, RequestStatus.Declined, RequestStatus.Cancelled,
]

export enum RequestSource {
    Tv       = 'tv',
    GuestApp = 'guest_app',
}

export enum PaymentMethod {
    Room = 'room',
}

/** How an invitation offers its booking times (§13.4.2). */
export enum BookingMode {
    Slots = 'slots',
    Free  = 'free',
}

export const BOOKING_MODES: BookingMode[] = [BookingMode.Slots, BookingMode.Free]

/** The free mode's steps, in minutes. */
export const BOOKING_STEPS: number[] = [15, 30, 60]

/** How room-service delivery is charged (§13.1.2). */
export enum DeliveryMode {
    Off   = 'off',
    Item  = 'item',
    Fixed = 'fixed',
}

export const DELIVERY_MODES: DeliveryMode[] = [DeliveryMode.Off, DeliveryMode.Item, DeliveryMode.Fixed]

/** What a room-service line is (§13.1.2). */
export enum RequestLineKind {
    Item     = 'item',
    Delivery = 'delivery',
}
